var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTerms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_450_2051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.643574 16.801H17.4881C17.6392 16.801 17.7852 16.7481 17.901 16.6518C18.0628 16.5163 21.7534 13.3414 21.9784 6.48804H3.88777C3.6636 12.7091 0.264701 15.6331 0.229379 15.6623C0.0223036 15.8373 -0.0538834 16.1231 0.039277 16.3774C0.131793 16.6311 0.372901 16.801 0.643574 16.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3555 2.62066H18.1327V1.9761C18.1327 1.61515 17.8491 1.33154 17.4882 1.33154C17.1272 1.33154 16.8436 1.61515 16.8436 1.9761V2.62066H13.5778V1.9761C13.5778 1.61515 13.2942 1.33154 12.9333 1.33154C12.5723 1.33154 12.2887 1.61515 12.2887 1.9761V2.62066H9.06591V1.9761C9.06591 1.61515 8.7823 1.33154 8.42135 1.33154C8.06039 1.33154 7.77678 1.61515 7.77678 1.9761V2.62066H4.55398C4.19303 2.62066 3.90942 2.90427 3.90942 3.26522V5.1989H22.0001V3.26522C22.0001 2.90427 21.7165 2.62066 21.3555 2.62066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7288 17.6401C18.3788 17.9315 17.9395 18.0901 17.4882 18.0901H3.90942V20.0238C3.90942 20.3801 4.19771 20.6684 4.55398 20.6684H21.3555C21.7118 20.6684 22.0001 20.3801 22.0001 20.0238V12.7985C20.7574 15.8473 19.0232 17.3936 18.7288 17.6401Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_450_2051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTerms);
export default __webpack_public_path__ + "static/media/ic-terms.ea38145f571261222e0ea844ccee8436.svg";
export { ForwardRef as ReactComponent };